<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="12"
            class="text-right"
          >
            <v-btn
              color="#FF3700"
              @click="createQuestion()"
            >
              New Question
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :items-per-page="questionsTable.itemsPerPage"
        :headers="questionsTable.headers"
        :items="questions"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="name"
        show-expand
        class="elevation-1 clickable"
        @click:row="edit"
      >
        <template v-slot:item.updated_at="{ item }">
          <span>{{ item.updated_at | diffHumans }}</span>
        </template>
        <template v-slot:item.controls="{ item }">
          <v-btn
            class="mt-n2"
            elevation="1"
            fab
            x-small
            icon
            color="red"
            @click.stop
            @click="deleteQuestion(item.id, item.name)"
          >
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <b>Answers:-</b>  {{ item.answers | formatAnswer }}
          </td>
        </template>
      </v-data-table>
    </v-card>
    <create-question
      v-if="showCreate"
      @closed="showCreate = false"
      @success="createSuccess"
    />
    <edit-question
      v-if="showEdit"
      :editinfo="editInfo"
      @closed="showEdit = false"
      @success="editSuccess"
    />
    <delete-dialog
      v-if="showDelete"
      :title="'Delete Question?'"
      @closed="showDelete = false"
      @confirmed="deleteConfirmed()"
    />
  </v-container>
</template>

<script>
  import axios from 'src/app-axios';
  import constants from 'src/constants';
  import moment from 'moment';
  import CreateQuestion from './CreateQuestion';
  import EditQuestion from './EditQuestion';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';

  export default {
    name: 'Questionnaire',
    components: {
      'create-question': CreateQuestion,
      'edit-question': EditQuestion,
      'delete-dialog': DeleteDialog,
    },
    filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },

      formatAnswer (answers) {
        var formatted = '';
        answers.map((value, key) => {
          if (key === (answers.length - 1)) {
            formatted += value.answer;

            return formatted;
          }
          formatted += value.answer + ' | ';
        });

        return formatted;
      },
    },

    data: () => ({
      questions: [],
      expanded: [],
      singleExpand: true,
      questionsTable: {
        headers: [
          { text: 'Name', align: 'left', value: 'name' },
          { text: 'Question', value: 'question' },
          { text: 'Type', value: 'type' },
          { text: 'Last Updated', value: 'updated_at' },
          { text: '', value: 'controls', sortable: false },
          { text: '', value: 'data-table-expand' },
        ],
        itemsPerPage: 10,
      },
      showCreate: false,
      loading: false,
      showEdit: false,
      editInfo: {},
      showDelete: false,
      deleteId: '',
      deleteName: '',
    }),

    created () {
      this.loading = true;
      this.getAllQuestionnaires();
    },

    methods: {
      createQuestion () {
        this.showCreate = true;
      },

      createSuccess () {
        this.getAllQuestionnaires();
        this.$store.dispatch('alert/onAlert', {
          message: 'New Questionnaire Added!',
          type: constants.ALERT_TYPE_SUCCESS,
        });
        this.showCreate = false;
      },

      deleteQuestion (id, name) {
        this.showDelete = true;
        this.deleteId = id;
        this.deleteName = name;
      },

      deleteConfirmed () {
        axios.delete('api/swift-checkin/questionnaire/' + this.deleteId)
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Question ' + this.deleteName + ' removed!',
              type: constants.ALERT_TYPE_SUCCESS,
            });
            this.showDelete = false;
            this.getAllQuestionnaires();
          })
          .catch(() => {
            this.showDelete = false;
            this.$store.dispatch('alert/onAlert', {
              message: 'Something went wrong in deleting the question.',
              type: constants.ALERT_TYPE_ERROR,
            });
          });
      },

      edit (row) {
        this.editInfo = row;
        this.showEdit = true;
      },

      editSuccess () {
        this.getAllQuestionnaires();
        this.$store.dispatch('alert/onAlert', {
          message: 'Questionnaire Updated!',
          type: constants.ALERT_TYPE_SUCCESS,
        });
        this.showCreate = false;
      },

      getAllQuestionnaires () {
        axios.get('api/swift-checkin/questionnaire').then(response => {
          this.questions = response.data;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'Something went wrong in getting questionnaires.',
            type: constants.ALERT_TYPE_ERROR,
          });
        });
      },
    },
  };
</script>

<style scoped>
  .clickable {
    cursor: pointer;
  }
</style>
